import styled from "styled-components";

const Width = styled.div`
  width: 90%;
  margin: 0 auto;
  height: 100%;
  max-width: 1200px;
`;

export default Width;
